var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0028 17L12.0028 7.4125L14.2892 9.70127C14.6788 10.0913 15.3182 10.0913 15.7078 9.70127C16.0974 9.31127 16.0974 8.68127 15.7078 8.29127L11.713 4.2925C11.3234 3.9025 10.6941 3.9025 10.3045 4.2925L6.29221 8.28875C5.9026 8.67875 5.9026 9.30875 6.29221 9.69875C6.68181 10.0887 7.31118 10.0887 7.70079 9.69875L10.0048 7.4125L10.0048 17C10.0048 17.55 10.4543 18 11.0038 18C11.5532 18 12.0028 17.55 12.0028 17Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/ArrowUpIcon.5b960a9388ed75792b54abc46791b390.svg";
export { ForwardRef as ReactComponent };